
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class BjlTable extends Vue {
    //百家乐
    table = {
        data: [],
        column: [
            {
                key: 'b_dealer',
                title: '下注庄金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.b_dealer) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_dealer.bet)
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'b_player',
                title: '下注闲金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.b_player) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_player.bet)
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'b_dealer_pair',
                title: '下注庄对金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.b_dealer_pair) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_dealer_pair.bet)
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'b_player_pair',
                title: '下注闲对金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.b_player_pair) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_player_pair.bet)
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'b_mix',
                title: '下注和金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.b_mix) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_mix.bet)
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'FireTimes',
                title: '庄开牌',
                align: 'center',
                width: '150',
                render: (h, params) => {
                    let strzo: any
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.dealer
                        str = strzo.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'FireTimes',
                title: '闲开牌',
                align: 'center',
                width: '150',
                render: (h, params) => {
                    let strzo: any
                    let str = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.player
                        str = strzo.poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'b_dealer',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let strzo = 0
                    if (JSON.parse(params.row.opt_detail).hits.total_bet) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.total_bet, 1)
                    } else {
                        if (JSON.parse(params.row.opt_detail).hits.hits.b_player) {
                            strzo += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_player.bet, 1)
                        }
                        if (JSON.parse(params.row.opt_detail).hits.hits.b_dealer) {
                            strzo += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_dealer.bet, 1)
                        }
                        if (JSON.parse(params.row.opt_detail).hits.hits.b_dealer_pair) {
                            strzo += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_dealer_pair.bet, 1)
                        }
                        if (JSON.parse(params.row.opt_detail).hits.hits.b_player_pair) {
                            strzo += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_player_pair.bet, 1)
                        }
                        if (JSON.parse(params.row.opt_detail).hits.hits.b_mix) {
                            strzo += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.b_mix.bet, 1)
                        }
                    }
                    return h('span', strzo.toFixed(2))
                }
            },
            {
                key: 'chang_point',
                title: '输赢',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
